module.exports = __webpack_public_path__ + "img/itc.85298645.svg";